import { render } from "./getMedicine.vue?vue&type=template&id=7631b65d&scoped=true"
import script from "./getMedicine.vue?vue&type=script&lang=js"
export * from "./getMedicine.vue?vue&type=script&lang=js"

import "./getMedicine.vue?vue&type=style&index=0&id=7631b65d&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7631b65d"]])

export default __exports__